import i18n from '../../../i18n';

interface TorizonPackage {
  id: string;
  name: string;
  version: string;
  createdAt: string;
  type: string;
}

export default TorizonPackage;

export const mockTorizonPackage = {
  id: 'pkg-os-2',
  name: 'torizon-os',
  version: '6.8.0',
  createdAt: '2026-02-01T00:00:00',
  type: 'OSTREE',
} as TorizonPackage;

export const getTorizonPackageLabel = (
  packageId: string | null | undefined,
  packages: TorizonPackage[] | null,
) => {
  if (packageId == null || packageId.length === 0) return i18n.t('info-not-set');
  if (packages == null) return i18n.t('error-torizon-catalogue-unavailable');
  const entry = packages.find((p) => p.id === packageId);
  if (entry == null) return i18n.t('info-torizon-package-deleted');
  return `${entry.name} · ${entry.version}`;
};
